import { PayloadAction, createSlice } from '@reduxjs/toolkit'
import IOption from '../interfaces/IOption'
import { IQuote } from '../interfaces/IQuote'

// TradeStation OAuth2 token response structure
export interface ITradeStationTokenData {
  access_token: string
  refresh_token?: string
  id_token?: string
  token_type: string
  scope: string
  expires_in: number
  issued_at?: number
}

export interface TradeStationState {
  tradeStationAccessToken: ITradeStationTokenData | null
  tradeStationOptions: IOption[]
  tradeStationQuotes: IQuote[]
}

export const tradeStationInitialState: TradeStationState = {
  tradeStationAccessToken: null,
  tradeStationOptions: [],
  tradeStationQuotes: []
}

export const tradeStationSlice = createSlice({
  name: 'tradeStation',
  initialState: tradeStationInitialState,
  reducers: {
    setTradeStationAccessToken: (state, action: PayloadAction<ITradeStationTokenData | null>) => {
      state.tradeStationAccessToken = action.payload
    },
    setTradeStationOptions: (state, action: PayloadAction<IOption[]>) => {
      state.tradeStationOptions = action.payload
    },
    setTradeStationQuotes: (state, action: PayloadAction<IQuote[]>) => {
      state.tradeStationQuotes = action.payload
    }
  }
})

export const { setTradeStationAccessToken, setTradeStationOptions, setTradeStationQuotes } = tradeStationSlice.actions

export default tradeStationSlice.reducer
